
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import DataTable from 'react-data-table-component';
import { api } from '../api';

function Products() {
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    api.getCategories().then(setCategories);
  }, []);

  useEffect(() => {
    setLoading(true);
    api.getProducts(page, limit).then(res => {
      setProducts(res.products);
      setPage(res.page);
      setLimit(res.limit);
      setTotal(res.total);
      setLoading(false);
    });
  }, [page, limit]);
  const [formData, setFormData] = useState({ id: '', name: '', icon: '', description: '', category: '', price: 0, stock: 0 });
  const [editFormData, setEditFormData] = useState({ id: '', name: '', icon: '', description: '', category: '', price: 0, stock: 0, sellerId: '' });
  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateError, setUpdateError] = useState('');
  // ...existing code...
  // No need for deleteId or deleteModalRef with JS confirm
  const columns = [
    { name: 'ID', selector: row => row.id, sortable: true },
    { name: 'Name', selector: row => row.name, sortable: true },
    { name: 'Category', selector: row => row.category?.name || '', sortable: true },
    { name: 'Price', selector: row => `$${row.price?.toFixed(2)}`, sortable: true },
    { name: 'Stock', selector: row => row.quantity, sortable: true },
    { name: 'Status', selector: row => row.status, sortable: true, cell: row => (
      <span className={`ec-status ${row.status === 'PUBLISHED' ? 'ec-active' : 'ec-inactive'}`}>{row.status}</span>
    ) },
    { name: 'Action', cell: row => (
      <div className="dropdown">
        <button className="btn btn-outline-secondary dropdown-toggle" type="button" id={`actionDropdown-${row.id}`} data-bs-toggle="dropdown" aria-expanded="false">
          Actions
        </button>
        <ul className="dropdown-menu" aria-labelledby={`actionDropdown-${row.id}`}>
          <li><button className="dropdown-item" onClick={() => openEditModal(row)}>Edit</button></li>
          <li><button className="dropdown-item text-danger" onClick={() => handleDeleteConfirm(row.id)}>Delete</button></li>
        </ul>
      </div>
    ), ignoreRowClick: true, allowOverflow: true, button: true },
  ];

  function handleInputChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: name === 'price' || name === 'stock' ? Number(value) : value }));
  }
  function handleEditInputChange(e) {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: name === 'price' || name === 'stock' ? Number(value) : value }));
  }
  function resetForm() {
    setFormData({ id: '', name: '', icon: '', description: '', category: '', price: 0, stock: 0 });
  }
  async function handleAdd(e) {
    e.preventDefault();
    if (!formData.name) return;
    const payload = {
      name: formData.name,
      icon: formData.icon,
      description: formData.description,
      category: formData.category,
      price: formData.price,
      quantity: formData.stock,
    };
    const created = await api.createProduct(payload);
    if (created) {
      setLoading(true);
      const res = await api.getProducts(page, limit);
      setProducts(res.products);
      setTotal(res.total);
      setLoading(false);
      resetForm();
      try {
        const modalEl = document.getElementById('addProduct');
        if (modalEl && window.bootstrap) {
          const modal = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
          modal.hide();
        }
      } catch {}
    }
  }
  function openEditModal(product) {
    setEditFormData({
      ...product,
      category: product.category && product.category.id ? product.category.id : product.category || '',
      sellerId: product.sellerId || '',
    });
    try {
      const modalEl = document.getElementById('editProduct');
      if (modalEl && window.bootstrap) {
        const modal = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
        modal.show();
      }
    } catch {}
  }
  async function handleUpdate(e) {
    e.preventDefault();
    setUpdateError('');
    if (!editFormData.id) return;
    setUpdateLoading(true);
    const payload = {
      name: editFormData.name,
      icon: editFormData.icon,
      description: editFormData.description,
      category: editFormData.category,
      price: editFormData.price,
      quantity: editFormData.stock,
      status: editFormData.status || 'PUBLISHED',
    };
    try {
      const updated = await api.updateProduct(editFormData.id, payload, editFormData.sellerId);
      if (updated) {
        setLoading(true);
        const res = await api.getProducts(page, limit);
        setProducts(res.products);
        setTotal(res.total);
        setLoading(false);
        try {
          const modalEl = document.getElementById('editProduct');
          if (modalEl && window.bootstrap) {
            const modal = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
            modal.hide();
          }
        } catch {}
      } else {
        setUpdateError(updated?.message || 'Failed to update product.');
      }
    } catch (err) {
      setUpdateError(err?.message || 'An error occurred while updating.');
    } finally {
      setUpdateLoading(false);
    }
  }
  function handleDeleteConfirm(id) {
    if (window.confirm('Are you sure you want to delete this product? This action cannot be undone.')) {
      handleDelete(id);
    }
  }

  async function handleDelete(id) {
    await api.deleteProduct(id);
    setLoading(true);
    const res = await api.getProducts(page, limit);
    setProducts(res.products);
    setTotal(res.total);
    setLoading(false);
  }


  return (
    <>
      <Helmet>
        <title>Product List | Owena Admin Dashboard</title>
      </Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Product List</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e) => e.preventDefault()}>Home</a></span>
                <span><i className="mdi mdi-chevron-right"></i></span>Products</p>
            </div>
            <div>
              <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addProduct"> Add Product</button>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  <DataTable
                    columns={columns}
                    data={products}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={total}
                    paginationPerPage={limit}
                    paginationDefaultPage={page}
                    onChangePage={setPage}
                    onChangeRowsPerPage={setLimit}
                    highlightOnHover
                    pointerOnHover
                    responsive
                    noDataComponent={<div className="text-center">No products found.</div>}
                  />
                </div>
              </div>
            </div>
          </div>


          <div className="modal fade" id="addProduct" tabIndex="-1" aria-labelledby="addProductLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header px-4">
                  <h5 className="modal-title" id="addProductLabel">Add Product</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body px-4">
                  <form onSubmit={handleAdd}>
                    <div className="mb-3"><label className="form-label" htmlFor="prd-name">Name</label><input id="prd-name" name="name" className="form-control" value={formData.name} onChange={handleInputChange} required /></div>
                    <div className="mb-3"><label className="form-label" htmlFor="prd-icon">Icon URL</label><input id="prd-icon" name="icon" className="form-control" value={formData.icon} onChange={handleInputChange} /></div>
                    <div className="mb-3"><label className="form-label" htmlFor="prd-description">Description</label><textarea id="prd-description" name="description" className="form-control" value={formData.description} onChange={handleInputChange} /></div>
                    <div className="mb-3"><label className="form-label" htmlFor="prd-category">Category</label>
                      <select id="prd-category" name="category" className="form-select" value={formData.category} onChange={handleInputChange} required>
                        <option value="">Select Category</option>
                        {categories.map(cat => (
                          <option key={cat.id} value={cat.id}>{cat.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3"><label className="form-label" htmlFor="prd-price">Price</label><input id="prd-price" name="price" type="number" step="0.01" className="form-control" value={formData.price} onChange={handleInputChange} /></div>
                    <div className="mb-3"><label className="form-label" htmlFor="prd-stock">Stock</label><input id="prd-stock" name="stock" type="number" className="form-control" value={formData.stock} onChange={handleInputChange} /></div>
                    <div className="d-flex justify-content-end gap-2"><button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={resetForm}>Cancel</button><button type="submit" className="btn btn-primary">Add</button></div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Edit Product Modal */}
          <div className="modal fade" id="editProduct" tabIndex="-1" aria-labelledby="editProductLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header px-4">
                  <h5 className="modal-title" id="editProductLabel">Edit Product</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body px-4">
                  <form onSubmit={handleUpdate}>
                    <div className="mb-3"><label className="form-label" htmlFor="edit-prd-name">Name</label><input id="edit-prd-name" name="name" className="form-control" value={editFormData.name} onChange={handleEditInputChange} required /></div>
                    <div className="mb-3"><label className="form-label" htmlFor="edit-prd-icon">Icon URL</label><input id="edit-prd-icon" name="icon" className="form-control" value={editFormData.icon} onChange={handleEditInputChange} /></div>
                    <div className="mb-3"><label className="form-label" htmlFor="edit-prd-description">Description</label><textarea id="edit-prd-description" name="description" className="form-control" value={editFormData.description} onChange={handleEditInputChange} /></div>
                    <div className="mb-3"><label className="form-label" htmlFor="edit-prd-category">Category</label>
                      <select id="edit-prd-category" name="category" className="form-select" value={editFormData.category} onChange={handleEditInputChange} required>
                        <option value="">Select Category</option>
                        {categories.map(cat => (
                          <option key={cat.id} value={cat.id}>{cat.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3"><label className="form-label" htmlFor="edit-prd-price">Price</label><input id="edit-prd-price" name="price" type="number" step="0.01" className="form-control" value={editFormData.price} onChange={handleEditInputChange} /></div>
                    <div className="mb-3"><label className="form-label" htmlFor="edit-prd-stock">Stock</label><input id="edit-prd-stock" name="stock" type="number" className="form-control" value={editFormData.stock} onChange={handleEditInputChange} /></div>
                    {updateError && <div className="alert alert-danger py-2 mb-2">{updateError}</div>}
                    <div className="d-flex justify-content-end gap-2">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                      <button type="submit" className="btn btn-primary" disabled={updateLoading}>
                        {updateLoading ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
                        {updateLoading ? 'Updating...' : 'Save Changes'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Products;
